export default __webpack_public_path__ + "static/media/mobile-tip.9a0a2dc2.png";